// extracted by mini-css-extract-plugin
export default {"f":"ca58867ce7","main":"d9369b3da1","btn":"_0d0d2666b9","w":"dd18e45c73","h":"be2eda9f52","lh25":"a871cf288e","wb":"_0810760004","b":"_5a443ae837","bx":"_772c211e14"};